export const messagesRu = {
  BrowserError: {
    Title: 'Неподдерживаемый браузер',
    Content: 'Смените ваш браузер на последний Chrome, Firefox или Opera чтобы продолжить.',
  },
  ServerError: {
    Title: 'Ошибка на сервере',
    Content: 'Произошла какая-то ошибка на нашем серере. Пожалуйста, простите нас. И попробуйте ещё раз.',
  },
};



// WEBPACK FOOTER //
// ./src/messages/messages-ru.ts